/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuInputRangeDimensions_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterDimensions_user$ref: FragmentReference;
export type SbRespRefineMenuFilterDimensions_user = {|
  +$fragmentRefs: SbSharedRefineMenuInputRangeDimensions_user$ref,
  +$refType: SbRespRefineMenuFilterDimensions_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5c095c96fa002ff53f39d14e3317552f';
module.exports = node;
